import { Component, Input, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  imageURL: SafeResourceUrl = 'assets/img/loading.gif'

  @Input() mensaje: string = 'Cargando...';

  constructor() { }

  ngOnInit() {
  }

}
